import type { PipeTransform } from '@angular/core';
import { inject, Pipe } from '@angular/core';
import { DiOccApiUrl } from '@di';

@Pipe({
  name: 'foerchNormalizeUrl',
  standalone: true,
})
export class FoerchNormalizeUrlPipe implements PipeTransform {
  private readonly _apiUrl = inject(DiOccApiUrl);

  transform(url: string): string {
    if (new RegExp(/^(http|data:image|\/\/)/i).test(url)) {
      return url;
    }
    return this._apiUrl + url;
  }
}
